import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';

import { PageLoader } from '@core-web/ui';

import store, { persistor } from '../../store';

interface IProps {
  children: any;
}

const ReduxGate = ({ children }: IProps): JSX.Element => (
  <Provider store={store}>
    <PersistGate loading={<PageLoader />} persistor={persistor}>
      {children}
    </PersistGate>
  </Provider>
);

export { ReduxGate as default };

export { store };
